import { MeasureTimemapEntry } from "./main";
import etaLoader from "../lib/EtaLoader";
export enum notifyStatus {
  success,
  failed,
  warning,
}

export type coords = {
  top: string | undefined;
  bottom: string | undefined;
  right: string | undefined;
  left: string | undefined;
};

export const notesStatusEvents = {
  NOTE_SUCCESS: 'noteSuccess',
  NOTE_FAILED: 'noteFailed',
  ALL_NOTES_IN_MEASURE_FINISHED: 'allNotesInMeasureFinished',
  MEASURE_SUCCESS: 'measureSuccess',
  PRACTICE_END: 'practiceEnd',
  SAMPLE_LOADED: 'sampleLoaded',
  STATS_SEND: 'statsSend',
} as const;

export type MeasureTimemap = MeasureTimemapEntry[];

export const NOT_ACTIVE_COLOR = '#C0C0C0';
export const ACTIVE_COLOR = '#000000';
export const SUCCESS_COLOR = '#008000';
export const FAILED_COLOR = '#FF0000';

// Extend the Window interface to include our new global functions
declare global {
  interface Window {
    popup: (message: string, status?: notifyStatus, position?: coords) => void;
    spinner: {
      show: (message: string, position?: coords) => void;
      hide: () => void;
    };
    mobx: any,
    manager: any,
    i18n: any,
    samplesModel: any,
    samplesSelectorModel: any,
    playbackControlModel: any,
    sheetEditorEntity: any,
    mapperEntity: any,
    selectorEntity: any,
    rendererSheetModel: any
    accessToken: string | undefined
    sentry: any
    apiSwagger: any;
    etaLoader: typeof etaLoader;
    CORE_BASE_URL: string;
    soundfontUrl: string;
    metronomeClickUrl: string;
    WEBAUDIOFONT_BASE_URL: string;
  }
}

// Message class for popup notifications
export class gMsg {
  msg: string;
  status: notifyStatus;
  coords: coords = {
    top: '10%',
    right: '8%',
    bottom: undefined,
    left: undefined,
  };
  constructor(
    _msg: string,
    _status: notifyStatus,
    _coords?: coords,
  ) {
    this.msg = _msg;
    this.status = _status;
    if (_coords) {
      this.coords = _coords;
    }
  }
}

export interface ManagerInstance {
  core: any;
  gMsg: any;
  renderer: any;
  spinnerMsg: string;
  spinnerPos: any;
  [key: string]: any;
}

export interface IRange {
  start: Coord | null;
  end: Coord | null;
}

export interface Coord {
  measure: number;
  offset: number;
  xCoord: number;
  yCoord: number;
  absoluteTime: number;
}

export enum SELECTED_HAND {
  NO_HAND = -1,
  RIGHT = 0,
  LEFT = 1
}

export const ADMIN_ROLE = "darpiano-admin"
export const USER_ROLE = "darpiano-user"
